import {reqWithToken} from './requestHelper';

export async function get(id) {
    return (await reqWithToken(`api/codeData/${id}`,)).data;
}

export async function getNo(id) {
    return (await reqWithToken(`api/codeData/getNo/${id}`,)).data;
}

export async function getAll() {
    return (await reqWithToken('api/codeData/getAll')).data;
}

export async function copyCodeSet(data) {
    return (await reqWithToken('api/codeData/copyCodeSet',{
        method: 'put',
        data: data
    })).data;
}

export async function getAllSet() {
    return (await reqWithToken('api/codeData/getAllSet')).data;
}

export async function update(data) {
    return (await reqWithToken('api/codeData/update',{
        method: 'put',
        data: data
    })).data;
}